export function hideSplash() {
    document.getElementById('splash').style.display = "none";
}